export default __webpack_public_path__ + "static/media/logo-inverted.102c5adf.webp";